module.exports = __webpack_public_path__ + "static/instant-feedback-8503580ac11d5ce657146f04d91eea18.png";